import React from 'react';
import { Route } from 'react-router';
import configureStore from '../redux/configure-store';
import FullScreenModalsRoutes from './routes';
import { Direction } from '../containers/direction';
import { widgetWrapper } from '../worker/widgetWrapper';
import { iframeWrapper } from '../worker/iframeWrapper';
import PaymentEventProxy from '../components/payment-events/proxy';
import { ReactReduxContext } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createHashHistory } from 'history';

const history = createHashHistory();

const createStore = ({ initialState, ...args }) =>
  configureStore({
    ...args,
    history,
    initialState: {
      ...initialState,
      isLightbox: true,
    },
  });

function Component() {
  return (
    <Direction>
      <PaymentEventProxy />
      <ConnectedRouter context={ReactReduxContext} history={history}>
        <Route path="/" component={FullScreenModalsRoutes} />
      </ConnectedRouter>
    </Direction>
  );
}

const WrappedWidget = widgetWrapper({ createStore, Component });

export const FullScreenModals = iframeWrapper(
  WrappedWidget,
  {
    getStoreBuilder: () => ({
      createStore,
    }),
  },
  false,
);
